import { navigate } from 'gatsby'

class NavigationHelper {
  public static navigate(to: string, opt?: any) {
    navigate(to, opt)
  }
}

export default NavigationHelper
